<template>
    <div class="earn-page">
        <AnimatedContent :distance="24" :duration="0.7">
            <section class="earn-hero">
                <h2>{{ $t('earnings.balance') }}</h2>
                <div class="earn-hero__line"></div>
                <div class="earn-hero__cols">
                    <div class="earn-hero__col">
                        <span>DOL</span>
                        <strong>
                            <NumberScroll :to="dolAmount" :decimal="true" :decimal-digits="2" :duration="1.8" />
                        </strong>
                        <p>
                            {{ $t('earnings.totalWithdraw') }}
                            <b>{{wdDol}}</b>
                        </p>
                    </div>
                    <div class="earn-hero__col">
                        <span>USDT</span>
                        <strong>
                            <NumberScroll :to="usdtAmount" :decimal="true" :decimal-digits="2" :duration="1.8" />
                        </strong>
                        <p>
                            {{ $t('earnings.totalWithdraw') }}
                            <b>{{wdUsdt}}</b>
                        </p>
                    </div>
                </div>
                <div class="earn-hero__actions">
                    <button class="earn-hero__btn earn-hero__btn--primary" type="button" @click="openRecharge">
                        {{ $t('earnings.recharge') }}
                    </button>
                    <button class="earn-hero__btn earn-hero__btn--ghost" type="button" @click="withdrawShow = true">
                        {{ $t('earnings.withdraw') }}
                    </button>
                </div>
            </section>
        </AnimatedContent>

        <AnimatedContent :distance="20" :duration="0.65" :delay="0.08">
            <div class="earn-stats">
                
                <div >
                    <p>
                        <img src="@/assets/img/earnings/icon-total.png" alt="">
                        <span>{{ $t('earnings.totalIncome') }}</span>
                    </p>
                    <strong>
                        <NumberScroll :to="totalRewards" :decimal="true" :decimal-digits="2" :duration="1.4" />
                    </strong>
                </div>

                <div >
                    <p>
                        <img src="@/assets/img/earnings/icon-mine.png" alt="">
                        <span>{{ $t('earnings.mineIncome') }}</span>
                    </p>
                    <strong>
                        <NumberScroll :to="wkRewards" :decimal="true" :decimal-digits="2" :duration="1.4" />
                    </strong>
                </div>

                <div >
                    <p>
                        <img src="@/assets/img/earnings/icon-referral.png" alt="">
                        <span>{{ $t('earnings.referral') }}</span>
                    </p>
                    <strong>
                        <NumberScroll :to="shareRewards" :decimal="true" :decimal-digits="2" :duration="1.4" />
                    </strong>
                </div>
            </div>
        </AnimatedContent>

        <FadeContent :blur="true" :delay="80" :duration="800">
            <section class="earn-card">
                <div class="earn-tabs">
                    <span :class="{ active: tab === 'income' }" @click="tab = 'income'">{{ $t('earnings.incomeLog') }}</span>
                    <span :class="{ active: tab === 'recharge' }" @click="tab = 'recharge'">{{ $t('earnings.rechargeLog') }}</span>
                    <span :class="{ active: tab === 'withdraw' }" @click="tab = 'withdraw'">{{ $t('earnings.withdrawLog') }}</span>
                </div>

                <template v-if="tab === 'income'">
                    <FadeContent
                        v-for="(item, index) in list1"
                        :key="index"
                        :delay="70 * index"
                        :duration="500"
                    >
                        <div class="earn-item" :class="{ 'is-split': index > 0 }">
                            <div>
                                <h3>{{ item.Remark }}</h3>
                                <p>
                                    <img src="@/assets/img/mining/icon-clock.png" alt="">
                                    {{ item.AddTime.replace('T',' ').slice(0,19) }}
                                </p>
                            </div>
                            <div class="earn-item__right">
                                <strong>
                                    <NumberScroll :to="Number(item.Amount)" :decimal="true" :decimal-digits="2" :duration="1.2" />
                                </strong>
                                <p>{{ $t('earnings.qty') }} <em>(DOL)</em></p>
                            </div>
                        </div>
                    </FadeContent>
                </template>

                <template v-else-if="tab === 'recharge'">
                    <FadeContent
                        v-for="(item, index) in list2"
                        :key="'rc-' + item.ID"
                        :delay="70 * index"
                        :duration="500"
                    >
                        <div class="earn-wd" :class="{ 'is-split': index > 0 }">
                            <div class="earn-wd__top">
                                <div class="earn-wd__meta">
                                    <p class="earn-wd__time">
                                        <img src="@/assets/img/mining/icon-clock.png" alt="">
                                        {{ item.addTime.replace('T',' ').slice(0,19) }}
                                    </p>
                                    <p class="earn-wd__addr">
                                        <img src="@/assets/img/earnings/icon-addr-wallet.png" alt="">
                                        {{ (item.Addr) }}
                                    </p>
                                </div>
                                <em class="earn-wd__status success" >{{ $t('earnings.success') }}</em>
                            </div>
                            <div class="earn-wd__nums">
                                <div>
                                    <label>{{ $t('earnings.rechargeQty') }} <em>({{ item.AccountType }})</em></label>
                                    <strong>
                                        <NumberScroll :to="item.Amount" :decimal="true" :decimal-digits="1" :duration="1.2" />
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </FadeContent>
                </template>

                <template v-else>
                    <FadeContent
                        v-for="(item, index) in list3"
                        :key="'wd-' + item.ID"
                        :delay="70 * index"
                        :duration="500"
                    >
                        <div class="earn-wd" :class="{ 'is-split': index > 0 }">
                            <div class="earn-wd__top">
                                <div class="earn-wd__meta">
                                    <p class="earn-wd__time">
                                        <img src="@/assets/img/mining/icon-clock.png" alt="">
                                         {{ item.AddTime.replace('T',' ').slice(0,19) }}
                                    </p>
                                    <p class="earn-wd__addr">
                                        <img src="@/assets/img/earnings/icon-addr-wallet.png" alt="">
                                        {{ (item.Addr) }}
                                    </p>
                                </div>
                                <em class="earn-wd__status 0" :class="item.Status">{{ $t('earnings.' + item.Status) }}</em>
                            </div>
                            <div class="earn-wd__nums">
                                <div>
                                    <label>{{ $t('earnings.withdrawQty') }} <em>({{item.AccountType}})</em></label>
                                    <strong>
                                        <NumberScroll :to="item.Amount" :decimal="true" :decimal-digits="1" :duration="1.2" />
                                    </strong>
                                </div>
                                <div class="earn-wd__nums-right">
                                    <label>{{ $t('earnings.receiveQty') }} <em>({{item.AccountType}})</em></label>
                                    <strong>
                                        <NumberScroll :to="item.AAmount" :decimal="true" :decimal-digits="2" :duration="1.2" />
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </FadeContent>
                </template>
            </section>
        </FadeContent>

        <Popup v-model="rechargeShow" round get-container="#app" class="earn-withdraw-popup" @closed="tokenMenu = false">
            <div class="earn-dialog">
                <div class="earn-dialog__head">
                    <h3>{{ $t('earnings.rechargeTitle') }}</h3>
                    <button type="button" @click="rechargeShow = false">
                        <img src="@/assets/img/mining/icon-close.png" alt="">
                    </button>
                </div>
                <div class="earn-dialog__input">
                    <input v-model="rechargeAmount" :placeholder="$t('earnings.rechargeMin')">
                    <button class="earn-dialog__token" type="button" @click.stop="tokenMenu = !tokenMenu">
                        <img :src="tokenIcon(rechargeToken)" alt="">
                        <span>{{ rechargeToken }}</span>
                        <i class="earn-dialog__chev" :class="{ open: tokenMenu }"></i>
                    </button>
                    <div v-show="tokenMenu" class="earn-dialog__menu" @click.stop>
                        <button
                            v-for="t in rechargeTokens"
                            :key="t"
                            type="button"
                            :class="{ active: rechargeToken === t }"
                            @click="selectRechargeToken(t)"
                        >
                            <img :src="tokenIcon(t)" alt="">
                            <span>{{ t }}</span>
                        </button>
                    </div>
                </div>
                <div class="earn-dialog__row earn-dialog__row--addr">
                    <span>
                        <img src="@/assets/img/earnings/icon-address.png" alt="">
                        {{ $t('earnings.rechargeAddress') }}
                    </span>
                    <b @click="copyAddress(rechargeAddress)">
                        {{ rechargeAddress }}
                    </b>
                </div>
                <button class="earn-dialog__btn" type="button" @click="doRecharge()">
                    {{ $t('earnings.confirmRecharge') }}
                </button>
            </div>
        </Popup>

        <Popup v-model="withdrawShow" round get-container="#app" class="earn-withdraw-popup">
            <div class="earn-dialog">
                <div class="earn-dialog__head">
                    <h3>{{ $t('earnings.withdrawTitle') }}</h3>
                    <button type="button" @click="withdrawShow = false">
                        <img src="@/assets/img/mining/icon-close.png" alt="">
                    </button>
                </div>
                <div class="earn-dialog__input">
                    <input v-model="withdrawAmount" :placeholder="$t('earnings.minAmount')">
                    <!-- <img src="@/assets/img/mining/token-fovo.png" alt="">
                    <span>FOVO</span> -->
                    <button class="earn-dialog__token" type="button" @click.stop="tokenMenu = !tokenMenu">
                        <img :src="tokenIcon(withdrawToken)" alt="">
                        <span>{{ withdrawToken }}</span>
                        <i class="earn-dialog__chev" :class="{ open: tokenMenu }"></i>
                    </button>
                    <div v-show="tokenMenu" class="earn-dialog__menu" @click.stop>
                        <button
                            v-for="t in withdrawTokens"
                            :key="t"
                            type="button"
                            :class="{ active: withdrawToken === t }"
                            @click="selectwithdrawToken(t)"
                        >
                            <img :src="tokenIcon(t)" alt="">
                            <span>{{ t }}</span>
                        </button>
                    </div>
                </div>
                <div class="earn-dialog__row">
                    <span>
                        <img src="@/assets/img/earnings/icon-to-account.png" alt="">
                        {{ $t('earnings.toAccount') }}
                    </span>
                    <b>{{ toAccount }} <em>{{withdrawToken}}</em></b>
                </div>
                <div class="earn-dialog__row">
                    <span>
                        <img src="@/assets/img/mining/icon-convert.svg" alt="">
                        {{ $t('earnings.fee') }}
                    </span>
                    <b>{{toFee}} <em>{{withdrawToken}}</em></b>
                </div>
                <div class="earn-dialog__row earn-dialog__row--addr">
                    <span>
                        <img src="@/assets/img/earnings/icon-address.png" alt="">
                        {{ $t('earnings.address') }}
                    </span>
                    <b @click="copyAddress(this.$store.state.globalAddress)">
                        {{ this.$store.state.globalAddress }}
                    </b>
                </div>
                <button class="earn-dialog__btn" type="button" @click="doWithdrawShow()">
                    {{ $t('earnings.confirmWithdraw') }}
                </button>
            </div>
        </Popup>
    </div>
</template>

<script>
import { Popup, Toast } from 'vant';
import AnimatedContent from '@/components/AnimatedContent/AnimatedContent.vue';
import FadeContent from '@/components/FadeContent/FadeContent.vue';
import NumberScroll from '@/components/NumberScroll.vue';
import { copyToClipboard } from '@/utils';


import axios from 'axios'
import contractaa from '../contract/index.js';


import Web3 from 'web3'
let web3
web3 = new Web3(window.ethereum);


export default {
    name: 'earnings-page',
    components: { Popup, AnimatedContent, FadeContent, NumberScroll },
    data() {
        return {
            tab: 'income',
            withdrawShow: false,
            rechargeShow: false,
            tokenMenu: false,
            withdrawAmount: '',
            rechargeAmount: '',
            rechargeToken: 'USDT',
            rechargeTokens: ['USDT', 'DOL'],
            withdrawToken: 'USDT',
            withdrawTokens: ['USDT', 'DOL'],
            rechargeAddress: '',
            withdrawAddress: '',
            list: [
                { id: 1, titleKey: 'referral', amount: '100.22', time: '2026-09-28 15:37:01' },
                { id: 2, titleKey: 'referral', amount: '100.22', time: '2026-09-28 15:37:01' },
                { id: 3, titleKey: 'mineIncome', amount: '100.22', time: '2026-09-28 15:37:01' },
                { id: 4, titleKey: 'mineIncome', amount: '100.22', time: '2026-09-28 15:37:01' },
                { id: 5, titleKey: 'mineIncome', amount: '100.22', time: '2026-09-28 15:37:01' },
            ],
            rechargeList: [
                { id: 21, status: 'success', amount: 100, unit: 'USDT', time: '2026-09-28 15:37:01', address: 'TE9h7tQgWewNRrTqVNtqVuTAj5aDKjfYJo' },
                { id: 22, status: 'pending', amount: 50, unit: 'DOL', time: '2026-09-28 15:37:01', address: 'TE9h7tQgWewNRrTqVNtqVuTAj5aDKjfYJo' },
                { id: 23, status: 'fail', amount: 80, unit: 'USDT', time: '2026-09-28 15:37:01', address: 'TE9h7tQgWewNRrTqVNtqVuTAj5aDKjfYJo' },
            ],
            withdrawList: [
                { id: 11, status: 'success', amount: 125.9, received: 100.22, time: '2026-09-28 15:37:01', address: 'TE9h7tQgWewNRrTqVNtqVuTAj5aDKjfYJo' },
                { id: 12, status: 'pending', amount: 125.9, received: 100.22, time: '2026-09-28 15:37:01', address: 'TE9h7tQgWewNRrTqVNtqVuTAj5aDKjfYJo' },
                { id: 13, status: 'fail', amount: 125.9, received: 100.22, time: '2026-09-28 15:37:01', address: 'TE9h7tQgWewNRrTqVNtqVuTAj5aDKjfYJo' },
            ],
            rechargeUAddr:'',
            rechargeDolAddr:'',
            dolAmount:0,
            usdtAmount:0,
            wdDol:0,
            wdUsdt:0,
            wkRewards:0,
            shareRewards:0,
            totalRewards:0,
            list1:[],
            list2:[],
            list3:[],
            timer: null,
            usdtfee:0,
            dolfee:0,
        };
    },
    computed: {
        stats() {
            return [
                { label: this.$t('earnings.totalIncome'), to: 20, decimal: false, icon: require('@/assets/img/earnings/icon-total.png') },
                { label: this.$t('earnings.mineIncome'), to: 15.9, decimal: true, icon: require('@/assets/img/earnings/icon-mine.png') },
                { label: this.$t('earnings.referral'), to: 15.9, decimal: true, icon: require('@/assets/img/earnings/icon-referral.png') },
            ];
        },
        toAccount() {
            const n = Number(this.withdrawAmount);
            let _toaccount = 0
            if(this.withdrawToken == 'USDT'){
                let _fee = this.usdtfee
                _toaccount = n - (n*_fee)
            }else{
                let _fee = this.dolfee
                _toaccount = n - (n*_fee)
            }
            return _toaccount
            
        },
        toFee() {
            const n = Number(this.withdrawAmount);
            let _toaccount = 0
            if(this.withdrawToken == 'USDT'){
                let _fee = this.usdtfee
                _toaccount = (n*_fee)
            }else{
                let _fee = this.dolfee
                _toaccount = (n*_fee)
            }
            return _toaccount
            
        },
        mappedIncome() {
            return this.list.map((item) => ({
                ...item,
                title: this.$t('earnings.' + item.titleKey),
            }));
        },
    },
    watch: {
        rechargeShow(val) {
            if (!val) this.tokenMenu = false;
        },
    },
    methods: {
        openRecharge() {
            this.tokenMenu = false;
            this.rechargeShow = true;
        },
        shortAddr(addr) {
            if (!addr || addr.length <= 20) return addr;
            return addr.slice(0, 20);
        },
        tokenIcon(token) {
            if (token === 'USDT') return require('@/assets/img/mining/token-usdt.png');
            return require('@/assets/img/mining/token-fovo.png');
        },
        selectRechargeToken(token) {

            this.rechargeToken = token;
            if(token=="USDT"){
                this.rechargeAddress = this.rechargeUAddr
            }else{
                this.rechargeAddress = this.rechargeDolAddr
            }
            this.tokenMenu = false;
        },
        selectwithdrawToken(token) {

            this.withdrawToken = token;
            this.tokenMenu = false;
        },
        async copyAddress(text) {
            await copyToClipboard(text);
            Toast(this.$t('layout.copied'));
        },
        //充值按钮
        async doRecharge(){
            let that = this
            let useraddr = this.$store.state.globalAddress

            that.$store.commit('handleShow', true)

        
            let usdtContract = new web3.eth.Contract(contractaa.abiUsdt,contractaa.usdtToken)
            let dolContract = new web3.eth.Contract(contractaa.abiABC,contractaa.abcToken)

            let amount = web3.utils.toWei(that.rechargeAmount,'ether')
            let payResult
            if(that.rechargeToken=="USDT"){
                payResult = await usdtContract.methods.transfer(that.rechargeAddress,amount).send({from:useraddr})
            }else{
                payResult = await dolContract.methods.transfer(that.rechargeAddress,amount).send({from:useraddr})
            }
            that.rechargeShow = false
            console.log("pay:"+payResult)
            that.$store.commit('handleShow', false)
            that.$toast.success(that.$t('layout.success'))
        },
        //提现按钮
        async doWithdrawShow(){
            let that = this
            let useraddr = this.$store.state.globalAddress
            that.$store.commit('handleShow', true)
            let vstr="user_wd"
            let vsign = await ethereum.request({method: "personal_sign",params: [vstr, useraddr]});

            let result = await axios.post(contractaa.APIURL+'?cmd=wd'+that.withdrawToken,"addr="+useraddr+"&singer="+vsign+"&amount="+that.withdrawAmount)
            if(result.data.Status){
                that.$store.commit('handleShow', false)  
                that.$toast.success(that.$t('layout.success'))

            }else{
                //that.$toast.fail(that.$t('layout.failed'))
                that.$toast.fail(result.data.Message)
                that.$store.commit('handleShow', false)  
            }
            that.withdrawShow = false
            that.getInfo()
        },
        async getInfo(){
            let that = this
            let useraddr = this.$store.state.globalAddress
            let axiosResult = await axios.post(contractaa.APIURL+'?cmd=earn','addr='+useraddr);
            if(axiosResult.status == 200){
                if(axiosResult.data.Status){
                    let _arr = axiosResult.data.Message.split('|')

                    that.rechargeUAddr = _arr[0]
                    that.rechargeDolAddr = _arr[1]
                    that.dolAmount = Number(_arr[2])
                    that.usdtAmount = Number(_arr[3])
                    that.wdDol = Number(_arr[4])
                    that.wdUsdt = Number(_arr[5])
                    that.wkRewards = Number(_arr[6])
                    that.shareRewards = Number(_arr[7])

                    that.totalRewards = that.wkRewards +that.shareRewards

                    that.usdtfee =Number(_arr[8])
                    that.dolfee = Number(_arr[9])

                }
            }
            if(this.rechargeToken=="USDT"){
                this.rechargeAddress = this.rechargeUAddr
            }else{
                this.rechargeAddress = this.rechargeDolAddr
            }

            let axiosFLResult = await axios.post(contractaa.APIURL+'?cmd=fl','page=1&addr='+useraddr);
            if(axiosFLResult.status == 200){
                if(axiosFLResult.data.Status){
                    that.list1 = axiosFLResult.data.Data
                }
            }
            let axiosreResult = await axios.post(contractaa.APIURL+'?cmd=re','page=1&addr='+useraddr);
            if(axiosreResult.status == 200){
                if(axiosreResult.data.Status){
                    that.list2 = axiosreResult.data.Data
                }
            }
            let axioswdResult = await axios.post(contractaa.APIURL+'?cmd=wd','page=1&addr='+useraddr);
            if(axioswdResult.status == 200){
                if(axioswdResult.data.Status){
                    that.list3 = axioswdResult.data.Data
                }
            }
        }
    },
    mounted(){
        this.getInfo()
        this.timer = setInterval(() => {
            this.getInfo()
        }, 10000)
    },
    beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
    },
};
</script>

<style lang="less" scoped>
.earn-page {
    padding: 8px 16px 12px;
    color: #101126;
}

.earn-hero {
    position: relative;
    width: 343px;
    height: 214px;
    padding: 15px;
    border-radius: 14px;
    box-sizing: border-box;
    overflow: hidden;
    background-color: #FEF3C5;
    background-image:
        radial-gradient(circle at 100% 3%, #FFFAE6 0%, rgba(254, 244, 196, 0) 135%),
        linear-gradient(121deg, #FEE78D 0%, #FEF3C5 100%);

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 14px;
        background: url('../../assets/img/earnings/hero-balance-bg.png') center / cover no-repeat;
        opacity: 0.78;
        pointer-events: none;
        z-index: 0;
    }

    &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -10px;
        width: 100%;
        height: 67px;
        background: #FFFFFF;
        opacity: 0.32;
        filter: blur(41px);
        pointer-events: none;
        z-index: 0;
    }

    h2 {
        position: relative;
        z-index: 1;
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        color: #101126;
    }

    &__line {
        position: relative;
        z-index: 1;
        margin: 14px -15px 0;
        height: 0.5px;
        opacity: 0.5;
        background: #FFFFFF;
    }

    &__cols {
        position: relative;
        z-index: 1;
        margin-top: 17px;
        display: flex;
    }

    &__col {
        flex: 1;
        min-width: 0;

        span {
            display: block;
            font-size: 12px;
            line-height: 12px;
            color: rgba(16, 17, 38, 0.7);
        }

        strong {
            display: block;
            margin-top: 10px;
            font-size: 22px;
            line-height: 22px;
            font-weight: 700;
            font-family: DINAlternate-Bold, sans-serif;
            color: #101126;

            span {
                font-family: inherit;
                font-size: inherit;
                font-weight: inherit;
                line-height: inherit;
                color: inherit;
            }
        }

        p {
            margin: 10px 0 0;
            display: flex;
            align-items: center;
            gap: 4px;
            font-size: 12px;
            line-height: 12px;
            color: rgba(16, 17, 38, 0.7);

            b {
                font-family: PingFang SC, sans-serif;
                font-weight: 400;
                font-size: 12px;
                line-height: 12px;
                color: #101126;
            }
        }
    }

    &__actions {
        position: relative;
        z-index: 1;
        margin-top: 20px;
        display: flex;
        gap: 13px;
    }

    &__btn {
        flex: 1;
        height: 40px;
        border: 0;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 500;
        color: #101126;

        &--primary {
            background-image: linear-gradient(-80deg, #FEC612 0%, #FFEC47 45%, #FED937 100%);
        }

        &--ghost {
            background: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(4px);
        }
    }
}

.earn-stats {
    margin-top: 10px;
    width: 343px;
    height: 77px;
    padding: 15px 0 0;
    display: flex;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 14px;

    > div {
        flex: 1;
        min-width: 0;
        padding-left: 15px;
        box-sizing: border-box;
        text-align: left;

        p {
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 12px;
            line-height: 12px;
            color: rgba(16, 17, 38, 0.7);

            img {
                width: 18px;
                height: 18px;
                border-radius: 6px;
                flex-shrink: 0;
            }
        }

        strong {
            display: block;
            margin-top: 8px;
            font-size: 24px;
            line-height: 24px;
            font-weight: 700;
            font-family: DINAlternate-Bold, sans-serif;
        }
    }
}

.earn-card {
    margin-top: 10px;
    width: 343px;
    padding: 15px;
    background: #FFFFFF;
    border-radius: 14px;
    box-sizing: border-box;
}

.earn-tabs {
    display: flex;
    align-items: flex-end;
    gap: 20px;
    margin: 0 -15px 16px;
    padding: 0 15px;
    border-bottom: 0.5px solid #E3E3E3;

    span {
        position: relative;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        color: #101126;
        opacity: 0.5;
        white-space: nowrap;
        padding-bottom: 11px;

        &.active {
            font-size: 16px;
            line-height: 22px;
            opacity: 1;
            font-weight: 600;

            &::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 3px;
                background: #101126;
                border-radius: 2px;
            }
        }
    }
}

.earn-wd {
    padding: 0 0 10px;

    &.is-split {
        padding-top: 10px;
        border-top: 0.5px solid #E3E3E3;
    }

    &__top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 8px;
    }

    &__time {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        line-height: 12px;
        color: rgba(16, 17, 38, 0.5);

        img {
            width: 10px;
            height: 10px;
            object-fit: contain;
        }
    }

    &__addr {
        margin-top: 9px;
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        line-height: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 220px;

        img {
            width: 10px;
            height: 10px;
            flex-shrink: 0;
            object-fit: contain;
        }
    }

    &__status {
        flex-shrink: 0;
        height: 22px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        font-style: normal;
        font-size: 13px;
        font-weight: 500;
        border-radius: 13px;

        &.success {
            color: #048C4D;
            background: #E5FAEC;
        }

        &.pending {
            color: #FE7F18;
            background: #FEF2E0;
        }

        &.fail {
            color: #E54712;
            background: #FAE7E5;
        }
        &.1 {
            color: #048C4D;
            background: #E5FAEC;
        }

        &.0 {
            color: #FE7F18;
            background: #FEF2E0;
        }

        &.2 {
            color: #E54712;
            background: #FAE7E5;
        }
    }

    &__nums {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;

        label {
            display: block;
            font-size: 12px;
            line-height: 12px;
            color: rgba(16, 17, 38, 0.7);

            em {
                font-style: normal;
                color: rgba(16, 17, 38, 0.5);
            }
        }

        strong {
            display: block;
            margin-top: 4px;
            font-size: 20px;
            line-height: 24px;
            font-family: DINAlternate-Bold, sans-serif;
        }

        &-right {
            text-align: right;
        }
    }
}

.earn-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 0 10px;

    &.is-split {
        padding-top: 10px;
        border-top: 0.5px solid #E3E3E3;
    }

    h3 {
        margin-top: 6px;
        font-size: 14px;
        line-height: 12px;
        font-weight: 500;
    }

    p {
        margin-top: 12px;
        display: flex;
        align-items: center;
        gap: 3px;
        font-size: 12px;
        line-height: 12px;
        color: rgba(16, 17, 38, 0.5);

        img {
            width: 10px;
            height: 10px;
            object-fit: contain;
        }
    }

    &__right {
        text-align: right;

        strong {
            font-size: 20px;
            line-height: 24px;
            font-weight: 700;
            font-family: DINAlternate-Bold, sans-serif;
        }

        p {
            justify-content: flex-end;
            color: rgba(16, 17, 38, 0.7);

            em {
                font-style: normal;
                color: rgba(16, 17, 38, 0.5);
            }
        }
    }
}

.earn-withdraw-popup {
    width: 302px;
    overflow: visible;
    background: #FFFFFF;
    border-radius: 14px;
    padding: 0;
}

.earn-dialog {
    width: 302px;
    padding: 14px 15px 20px;
    color: #101126;
    box-sizing: border-box;

    &__head {
        position: relative;
        height: 22px;
        margin-bottom: 19px;
        display: flex;
        align-items: center;
        justify-content: center;

        h3 {
            font-size: 16px;
            font-weight: 600;
            line-height: 22px;
        }

        button {
            position: absolute;
            right: 0;
            top: 3px;
            width: 16px;
            height: 16px;
            padding: 0;
            border: 0;
            background: transparent;
            line-height: 0;

            img {
                width: 16px;
                height: 16px;
            }
        }
    }

    &__input {
        position: relative;
        width: 272px;
        height: 50px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        background: #FAFBFC;
        border: 1px solid #E3E3E3;
        border-radius: 10px;
        box-sizing: border-box;
        margin-bottom: 15px;

        input {
            flex: 1;
            min-width: 0;
            border: 0;
            outline: none;
            background: transparent;
            font-size: 14px;
            line-height: 12px;
            color: #101126;

            &::placeholder {
                color: rgba(16, 17, 38, 0.66);
            }
        }

        > img {
            width: 18px;
            height: 18px;
            margin-right: 5px;
            flex-shrink: 0;
        }

        > span {
            font-weight: 500;
            font-size: 14px;
            line-height: 14px;
            color: #101126;
        }
    }

    &__token {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        padding: 0;
        border: 0;
        background: transparent;
        flex-shrink: 0;

        img {
            width: 18px;
            height: 18px;
            border-radius: 50%;
        }

        span {
            font-weight: 500;
            font-size: 14px;
            line-height: 14px;
            color: #101126;
        }
    }

    &__chev {
        width: 0;
        height: 0;
        border-left: 3.5px solid transparent;
        border-right: 3.5px solid transparent;
        border-top: 4px solid #101126;
        transition: transform 0.2s;

        &.open {
            transform: rotate(180deg);
        }
    }

    &__menu {
        position: absolute;
        top: 48px;
        right: 8px;
        z-index: 5;
        width: 127px;
        background: #FFFFFF;
        border: 0.5px solid #E7E7E7;
        border-radius: 10px;
        box-shadow: 0 8px 24px rgba(16, 17, 38, 0.12);
        overflow: hidden;

        button {
            width: 100%;
            height: 34px;
            padding: 0 15px;
            border: 0;
            background: transparent;
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 12px;
            color: #101126;

            img {
                width: 16px;
                height: 16px;
                border-radius: 50%;
            }

            &.active {
                background: rgba(252, 238, 153, 0.3);
            }
        }
    }

    &__row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        height: 40px;
        border-bottom: 0.5px solid #E3E3E3;

        span {
            display: flex;
            align-items: center;
            gap: 8px;
            flex-shrink: 0;
            font-size: 12px;
            line-height: 12px;
            color: rgba(16, 17, 38, 0.5);

            img {
                width: 18px;
                height: 18px;
                border-radius: 6px;
                flex-shrink: 0;
            }
        }

        b {
            font-size: 12px;
            line-height: 12px;
            font-weight: 500;
            text-align: right;
            color: #101126;
            white-space: nowrap;

            em {
                font-style: normal;
                font-weight: 500;
                color: #575867;
            }
        }

        &--addr {
            height: auto;
            min-height: 40px;
            align-items: flex-start;
            padding-top: 11px;
            border-bottom: 0;

            b {
                width: 186px;
                flex: none;
                line-height: 18px;
                white-space: normal;
                word-break: break-all;
                cursor: pointer;
            }
        }
    }

    &__btn {
        display: block;
        margin-top: 20px;
        width: 272px;
        height: 40px;
        border: 0;
        border-radius: 10px;
        background-image: linear-gradient(-57deg, #FEC612 0%, #FFEC47 45%, #FED937 100%);
        font-size: 14px;
        font-weight: 500;
        color: #101126;
    }
}
</style>
